export * from './delete-feld-kategorie.component';
export * from './delete-feld-kategorie.component.module';